import { z } from 'zod';

import { CatalogDefaultAccountKeySchema } from '../products/product.schemas.js';

import { ServicePricingBodySchema } from './service-pricing.schemas.js';

export const RegisterServiceBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  categoryId: z.uuid().optional(),
  serviceTypeId: z.uuid().optional(),
  isThirdParty: z.boolean().optional(),
  usefulLifeMonths: z.number().int().nonnegative().optional(),
  usefulLifeMeters: z.number().int().nonnegative().optional(),
  alertMonths: z.number().int().nonnegative().optional(),
  alertMeters: z.number().int().nonnegative().optional(),
  code: z.string().trim().max(50).optional(),
  description: z.string().trim().max(5000).optional(),
  estimatedDurationMinutes: z.number().int().positive().optional(),
  warrantyMonths: z.number().int().nonnegative().optional(),
  warrantyMeters: z.number().int().nonnegative().optional(),
  pricing: ServicePricingBodySchema.optional(),
  defaultRevenueAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
  defaultCostAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
  commissionRateBps: z.number().nullable().optional(),
});

export const RegisterServiceResponseSchema = z.object({
  serviceId: z.uuid(),
});

export type RegisterServiceBody = z.infer<typeof RegisterServiceBodySchema>;
export type RegisterServiceResponse = z.infer<typeof RegisterServiceResponseSchema>;
